export default __webpack_public_path__ + "static/media/carouselImage5.1f7247fc.jpg";